import { Link } from 'react-router-dom';

export default function Privacy() {
  return (
    <div data-testid="privacy-page">
      <section className="bg-white py-12 md:py-20">
        <div className="container mx-auto px-6 md:px-12 lg:px-24">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl sm:text-5xl font-bold mb-8" style={{ fontFamily: 'Poppins, sans-serif' }}>
              Privacy <span className="text-[#1E88E5]">Policy</span>
            </h1>

            <div className="prose prose-lg max-w-none text-[#334155]">
              <p className="text-lg mb-6">
                <strong>Effective Date:</strong> January 1, 2024
              </p>

              <p className="mb-6">
                Gomez Cleaning Service LLC ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your information when you visit our website or use our services.
              </p>

              <h2 className="text-2xl font-bold text-[#0F172A] mt-10 mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Information We Collect
              </h2>
              <p className="mb-4">We may collect the following types of information:</p>
              <ul className="list-disc pl-6 mb-6 space-y-2">
                <li><strong>Personal Information:</strong> Name, email address, phone number, and address when you contact us or request a quote.</li>
                <li><strong>Service Information:</strong> Details about the cleaning services you request.</li>
                <li><strong>Website Usage Data:</strong> Information about how you use our website, including IP address, browser type, and pages visited.</li>
              </ul>

              <h2 className="text-2xl font-bold text-[#0F172A] mt-10 mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
                How We Use Your Information
              </h2>
              <p className="mb-4">We use the information we collect to:</p>
              <ul className="list-disc pl-6 mb-6 space-y-2">
                <li>Respond to your inquiries and provide quotes</li>
                <li>Schedule and perform cleaning services</li>
                <li>Communicate with you about your services</li>
                <li>Improve our website and services</li>
                <li>Send promotional communications (with your consent)</li>
              </ul>

              <h2 className="text-2xl font-bold text-[#0F172A] mt-10 mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Information Sharing
              </h2>
              <p className="mb-6">
                We do not sell, trade, or rent your personal information to third parties. We may share your information only in the following circumstances:
              </p>
              <ul className="list-disc pl-6 mb-6 space-y-2">
                <li>With service providers who assist us in operating our business</li>
                <li>When required by law or to protect our rights</li>
                <li>With your explicit consent</li>
              </ul>

              <h2 className="text-2xl font-bold text-[#0F172A] mt-10 mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Data Security
              </h2>
              <p className="mb-6">
                We implement appropriate security measures to protect your personal information. However, no method of transmission over the internet is 100% secure, and we cannot guarantee absolute security.
              </p>

              <h2 className="text-2xl font-bold text-[#0F172A] mt-10 mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Your Rights
              </h2>
              <p className="mb-4">You have the right to:</p>
              <ul className="list-disc pl-6 mb-6 space-y-2">
                <li>Access the personal information we hold about you</li>
                <li>Request correction of inaccurate information</li>
                <li>Request deletion of your information</li>
                <li>Opt out of marketing communications</li>
              </ul>

              <h2 className="text-2xl font-bold text-[#0F172A] mt-10 mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Cookies
              </h2>
              <p className="mb-6">
                Our website may use cookies to enhance your browsing experience. You can choose to disable cookies through your browser settings, though this may affect some website functionality.
              </p>

              <h2 className="text-2xl font-bold text-[#0F172A] mt-10 mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Changes to This Policy
              </h2>
              <p className="mb-6">
                We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new policy on this page and updating the effective date.
              </p>

              <h2 className="text-2xl font-bold text-[#0F172A] mt-10 mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Contact Us
              </h2>
              <p className="mb-6">
                If you have any questions about this Privacy Policy, please contact us:
              </p>
              <ul className="list-none mb-6 space-y-2">
                <li><strong>Email:</strong> gelvia26@gmail.com</li>
                <li><strong>Phone:</strong> (323) 378-0061</li>
                <li><strong>Address:</strong> Sylmar, CA 91342</li>
              </ul>

              <div className="mt-10 pt-6 border-t border-[#E2E8F0]">
                <Link to="/" className="text-[#1E88E5] hover:underline">
                  ← Back to Home
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
